import { Formik, Form } from 'formik';
import React from 'react';
import TextInput from '../../Atoms/Inputs/TextInput';
import Buttons from '../../Atoms/Buttons/Buttons';
import Modal from '../../Atoms/Modal/Modal';
import * as Yup from 'yup';
import passwordIcon from '../../../assets/Imagess/ProfilePsswordIcon.svg';
import { useChangePassword } from '../../../Hooks/Users';
import styles from './RolesTable.module.css';
import LoaderButton from '../Loader/LoaderButton';
import { useToast } from '../Custom/CustomToaster/Toast';
const ResetPasswordForm = ({ handleOnClose, eachUser, refetchUsers }) => {
  const { mutate: changePassword, isLoading } = useChangePassword();
  const initialValues = {
    newPassword: '',
    repeatesNewPassword: '',
  };

  const customizedToast = useToast();

  const validationSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required('Password is required')
      .min(8, 'Password must be at least 8 characters')
      .max(15, 'Password must not exceed 15 characters')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
        'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
      ),
    repeatesNewPassword: Yup.string()
      .required('Confirm Password is required')
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        changePassword(
          {
            UserId: eachUser?.userId,
            password: values.repeatesNewPassword,
          },
          {
            onSuccess: () => {
              handleOnClose();
              refetchUsers();
              customizedToast.open('تم تغيير كلمة المرور بنجاح');
            },
            onError: (error) => {
              console.error('Password change error', error);
            },
          }
        );
      }}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => {
        return (
          <Form>
            <Modal
              width="40%"
              title="تغيير كلمة المرور" // Change Password
              onClose={handleOnClose}
              closeWhite={false}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  paddingTop: '15px',
                }}
              >
                <TextInput
                  label="كلمة المرور الجديدة" // New Password
                  icon={passwordIcon}
                  placeholder="كلمة المرور الجديدة" // New Password
                  name="newPassword"
                  value={values.newPassword}
                  required={true}
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                  errors={errors.newPassword}
                  touched={touched.newPassword}
                  type="password"
                  left
                />
                <p style={{ color: '#f3223c' }}>{errors.newPassword}</p>
                <TextInput
                  label="إعادة كلمة المرور الجديدة" // Repeat New Password
                  icon={passwordIcon}
                  placeholder="إعادة كلمة المرور الجديدة" // Repeat New Password
                  name="repeatesNewPassword"
                  value={values.repeatesNewPassword}
                  required={true}
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                  errors={errors.repeatesNewPassword}
                  touched={touched.repeatesNewPassword}
                  type="password"
                  left
                />
                <p style={{ color: '#f3223c' }}>{errors.repeatesNewPassword}</p>
                <div className={styles['button-input-container']}>
                  {isLoading ? (
                    <LoaderButton />
                  ) : (
                    <Buttons
                      text="حفظ كلمة المرور" // Save Password
                      handleOnClick={handleSubmit}
                      type="submit"
                      rounded
                    />
                  )}
                </div>
              </div>
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ResetPasswordForm;
